<template>
    <v-menu
        v-model="isMenuOpen"
        content-class="overflow-y-hidden dropmenu pa-1 elevation-0 set-background taskmenu-dropdown"
        :top="!$vuetify.breakpoint.mdAndUp"
        :bottom="$vuetify.breakpoint.mdAndUp"
        open-on-hover
        transition="slide-y-transition"
        offset-y
        nudge-left="16"
    >
        <template v-slot:activator="{ on }">
            <slot :on="on" />
        </template>
        <v-card
            class="date-range set-background"
        >
            <v-row
                no-gutters
                justify="start"
                align="start"
            >
                <v-col>
                    <TaskButtons :is-menu-open="isMenuOpen" />
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>
import { Router } from "../../composables/Router";
import TaskModule from "../../store/modules/task";
import { ref } from "@vue/composition-api";
import TaskButtons from "@/views/Task/TaskButtonsList.vue";

export default {
    name: "AppToolbarNewTask",
    components: {
        TaskButtons
    },
    setup() {
        const { openTask } = new TaskModule();
        const router = Router();
        const isMenuOpen = ref(false);

        const newTask = function() {
            let props = {};

            if (router.currentRoute.name.startsWith("client_")) {
                props.client_id = parseInt(router.currentRoute.params.id);
            }

            openTask(0, props);
        };

        return {
            newTask,
            isMenuOpen
        };
    }
};
</script>

<style>
.set-background {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    line-height: 1 !important;
}
</style>
